// Opens <dialog class="fp-dialog"> elements rendered by snippets/fp-video-modal.liquid.
// Any element with data-fp-modal-open="<dialog id>" opens that dialog; closing pauses the video
// and returns focus to the opener. One delegated listener, so it works for cards added later.

if (!window.fpVideoModal) {
  window.fpVideoModal = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-fp-modal-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpModalOpen);
      if (!(dialog instanceof HTMLDialogElement)) return;
      event.preventDefault();
      dialog.fpOpener = opener;
      dialog.showModal();
      // Posters are deferred (data-poster) so 39 closed dialogs don't download 39 portraits on page load.
      const v0 = dialog.querySelector('video[data-poster]');
      if (v0) { v0.poster = v0.dataset.poster; delete v0.dataset.poster; }
      // Caption tracks are deferred the same way (a <track src> downloads even inside a closed dialog).
      const tr = dialog.querySelector('track[data-src]');
      if (tr) { tr.src = tr.dataset.src; delete tr.dataset.src; }
      const video = dialog.querySelector('video');
      if (video) video.play().catch(() => {});
      return;
    }

    const closer = event.target.closest('[data-fp-modal-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    // Click on the backdrop (the dialog element itself, outside its content box) closes it.
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('fp-dialog')) {
      const rect = event.target.getBoundingClientRect();
      const inside =
        event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) event.target.close();
    }
  });

  document.addEventListener(
    'close',
    (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('fp-dialog')) return;
      dialog.querySelector('video')?.pause();
      dialog.fpOpener?.focus();
    },
    true
  );
}
